import {reportingFilterInputStyles, reportingMenuPaperStyles} from '../utils/ReportingToolbarDesign';

export const dashboardMetricInputStyles = {
    ...reportingFilterInputStyles,
    minWidth: 150,
    '& .MuiOutlinedInput-root': {
        ...reportingFilterInputStyles['& .MuiOutlinedInput-root'],
        height: 38
    },
    '& .MuiSelect-select': {
        py: '9px', px: 1.5, minHeight: '0 !important', lineHeight: '20px',
        borderRadius: 'inherit', bgcolor: 'transparent'
    }
};

export const dashboardMetricMenuProps = {
    PaperProps: {sx: {...reportingMenuPaperStyles, width: 'auto', maxHeight: 360}}
};
